<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class=WordSection1>

  <p class=MsoNormal style='text-align:center'><strong><span lang=FR-CH
                                                             style='font-size:15.0pt;font-family:"Times New Roman", sans-serif;color:#1F4E79'>Politique
de confidentialité </span></strong></p>

  <p class=MsoNormal style='text-align:center'><strong><span lang=FR-CH
                                                             style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#1F4E79'>&nbsp;</span></strong>
  </p>

  <p class=MsoListParagraph style='margin-left:46.35pt;text-indent:-18.0pt'><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>1.<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>GENERAL </span></strong></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif'>En application du Code rural, Chapitre IV,
Equarrissage, et la législation connexe, le site internet Provalt Equarrissage
(accessible à l’adresse internet https://provalt.fr) et les
applications mobiles (Provalt Equarrissage pour Android et Provalt Equarrissage
pour iOS) collectent des données à caractère personnel. </span></p>

  <p class=MsoNormal><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>&nbsp;</span></p>

  <p class=MsoListParagraph style='margin-left:46.35pt;text-indent:-18.0pt'><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>2.<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>DEFINITIONS </span></strong></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif'>Au sens de la <span style='color:#262626'>Loi n°
78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux
libertés, c</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#262626'>onstituent <em>une donnée à caractère personnel</em> toutes
informations relatives à une personne physique identifiée ou qui peut être
identifiée, directement ou indirectement, par référence à un numéro
d'identification ou à un ou plusieurs éléments qui lui sont propres. Pour
déterminer si une personne est identifiable, il convient de considérer
l'ensemble des moyens en vue de permettre son identification dont dispose ou
auxquels peut avoir accès le responsable du traitement ou toute autre personne.</span></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#262626'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#262626'>Constituent un <em>traitement de
données à caractère personnel</em> toutes opérations ou tout ensemble
d'opérations portant sur de telles données, quel que soit le procédé utilisé,
et notamment la collecte, l'enregistrement, l'organisation, la conservation,
l'adaptation ou la modification, l'extraction, la consultation, l'utilisation,
la communication par transmission, diffusion ou toute autre forme de mise à
disposition, le rapprochement ou l'interconnexion, ainsi que le verrouillage,
l'effacement ou la destruction.</span></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#262626'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#262626'>Constitue un <em>fichier de données
à caractère personnel</em> tout ensemble structuré et stable de données à
caractère personnel accessibles selon des critères déterminés.</span></p>

  <p class=MsoNormal style='text-align:justify'><em><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#262626'>&nbsp;</span></em></p>

  <p class=MsoNormal style='text-align:justify'><em><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#262626'>La personne concernée par un
traitement de données à caractère personnel</span></em><span style='font-size:
10.0pt;font-family:"Times New Roman", sans-serif;color:#262626'> est celle à laquelle se
rapportent les données qui font l'objet du traitement.</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify'><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#262626'>&nbsp;</span></p>

  <p class=MsoListParagraph style='margin-left:46.35pt;text-align:justify;
text-indent:-18.0pt'><strong><span lang=FR-CH style='font-size:10.0pt;font-family:
"Times New Roman", sans-serif'>3.<span style='font:7.0pt "Times New Roman", sans-serif'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></strong><strong><span lang=FR-CH style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>DONNEES
A CARACTERE PERSONNEL COLLECTEES PAR Provalt </span></strong></p>

  <p class=MsoNormal style='text-align:justify'><span lang=FR-CH
                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>Les données à caractère personnel
collectées par </span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>le
site internet Provalt Equarrissage et leurs applications mobiles peuvent
notamment inclure&nbsp;: </span></p>

  <p class=MsoListParagraph style='margin-left:67.65pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>1)<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>Nom/prénom de
l’utilisateur </span></p>

  <p class=MsoListParagraph style='margin-left:67.65pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>2)<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>Numéro de téléphone
fixe/mobile/fax de l’utilisateur et/ou de l’exploitant</span></p>

  <p class=MsoListParagraph style='margin-left:67.65pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>3)<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>Numéro de l’élevage si
disponible</span></p>

  <p class=MsoListParagraph style='margin-left:67.65pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>4)<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>Identifiant et mot de
passe</span></p>

  <p class=MsoListParagraph style='margin-left:67.65pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>5)<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>Courriel</span></p>

  <p class=MsoListParagraph style='margin-left:67.65pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>6)<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>Adresse physique du
lieu de collecte et du siège social ou adresse de facturation</span></p>

  <p class=MsoListParagraph style='margin-left:67.65pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>7)<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>Point GPS relatif au
lieu de collecte </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=FR-CH
                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>&nbsp;</span>
  </p>

  <p class=MsoListParagraph style='margin-left:46.35pt;text-align:justify;
text-indent:-18.0pt'><strong><span lang=FR-CH style='font-size:10.0pt;font-family:
"Times New Roman", sans-serif'>4.<span style='font:7.0pt "Times New Roman", sans-serif'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></strong><strong><span lang=FR-CH style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>ACCES
AUX DONNEES ET RECTIFICATION DES DONNEES </span></strong></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif'>Le site internet Provalt Equarrissage et leurs
applications mobiles donnent accès aux données collectées selon la
règlementation prévue par les bases légales qui s’appliquent à son domaine
d’activité ou autrement, en l’application du principe de&nbsp;«&nbsp;besoin
d’en connaître&nbsp;».</span></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif'>Les modalités de rectification des données à
caractère personnel, ainsi que l’accès à ces données sont règlementées par la
loi. </span></p>

  <p class=MsoNormal style='margin-left:7.1pt;text-align:justify'><span
    lang=FR-CH style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>&nbsp;</span></p>

  <p class=MsoListParagraph style='margin-left:46.35pt;text-align:justify;
text-indent:-18.0pt'><strong><span lang=FR-CH style='font-size:10.0pt;font-family:
"Times New Roman", sans-serif'>5.<span style='font:7.0pt "Times New Roman", sans-serif'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></strong><strong><span lang=FR-CH style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>SECURITE
DES DONNEES</span></strong></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif'>Le détenteur du site internet Provalt Equarrissage
et des applications mobiles essaie d’assurer les plus hauts standards de
protection des données à caractère personnel possible. Il s’efforce, dans le
cadre légal français et européen, à sécuriser et à protéger les données
personnelles de ses utilisateurs. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=FR-CH
                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>&nbsp;</span>
  </p>

  <p class=MsoListParagraph style='margin-left:46.35pt;text-align:justify;
text-indent:-18.0pt'><strong><span lang=FR-CH style='font-size:10.0pt;font-family:
"Times New Roman", sans-serif'>6.<span style='font:7.0pt "Times New Roman", sans-serif'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></strong><strong><span lang=FR-CH style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>CONSERVATION
DES DONNEES PERSONNELLES </span></strong></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif'>Le détenteur du site internet Provalt Equarrissage
et des applications mobiles conservent les données à caractère personnel
collectées selon les prévisions légales applicable à leur domaine d’activité en
vigueur. </span></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif'>&nbsp;</span></p>

  <p class=MsoListParagraph style='margin-left:46.35pt;text-align:justify;
text-indent:-18.0pt'><strong><span lang=FR-CH style='font-size:10.0pt;font-family:
"Times New Roman", sans-serif'>7.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></strong><strong><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>MODIFICATION
DE LA POLITIQUE DE CONFIDENTIALITE </span></strong></p>

  <p class=MsoNormal style='text-align:justify'><span lang=FR-CH
                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif'>La présente politique de
confidentialité doit être en accord avec les développements légaux règlementant
le domaine d’activité du détenteur du site </span><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif'>internet Provalt Equarrissage et des
applications mobiles. L’utilisateur doit se tenir informé sur ces aspects. </span></p>

  <p class=MsoNormal style='text-align:right'><em><span lang=FR-CH
                                                        style='font-family:"Times New Roman", sans-serif'>Dernière mise à jour&nbsp;: 22 mai
2017</span></em></p>
</div>
